import { useCallback } from "react";
import { useFileExplorerSearchParams } from "./useFileExplorerSearchParams";
import { toApiSortColumn, areColumnsEqual } from "../../utils/sortUtils";

export function useFileExplorerSorting() {
  const { search, updateSearchParams } = useFileExplorerSearchParams();

  const handleSort = useCallback(
    (column: string) => {
      const currentSortBy = search.sortBy;
      const currentSortDirection = search.sortDirection;

      const apiColumn = toApiSortColumn(column);

      let newSortDirection: "ASC" | "DESC" = "ASC";
      if (
        areColumnsEqual(currentSortBy, column) &&
        currentSortDirection === "ASC"
      ) {
        newSortDirection = "DESC";
      }

      updateSearchParams({
        sortBy: apiColumn,
        sortDirection: newSortDirection,
      });
    },
    [search.sortBy, search.sortDirection, updateSearchParams]
  );

  return {
    sortBy: search.sortBy,
    sortDirection: search.sortDirection,
    handleSort,
  };
}
